<template>
  <BaseHowl
    ref="howl"
    :url="require('@/assets/audio/lobby-music.mp3')"
    :loop="true"
  />
</template>

<script>
import BaseHowl from '@/components/BaseHowl/BaseHowl'
import { mapState } from 'vuex'
export default {
  components: {
    BaseHowl
  },
  computed: mapState('ui', [
    'backgroundMusicState'
  ]),
  watch: {
    backgroundMusicState (state) {
      this.$refs['howl'].fade(state)
    }
  },
  methods: {
    play () {
      this.$refs['howl'].play()
    }
  }
}
</script>
